import { render, staticRenderFns } from "./LaundryQc.vue?vue&type=template&id=39e1586c"
import script from "./LaundryQc.vue?vue&type=script&lang=js"
export * from "./LaundryQc.vue?vue&type=script&lang=js"
import style0 from "./LaundryQc.vue?vue&type=style&index=0&id=39e1586c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports